<template>
  <aside class="sidebar">
    <div class="section">
      <div
        v-for="item in sidebarItems"
        :key="item.routeName"
        class="link"
        :class="{ active: $route.name === item.routeName }"
        @click="navigateTo(item.path)"
      >
        {{ item.title }}
      </div>
      <div
        class="link" 
        v-if="showExtendedLinks"
        :class="{ active: $route.name === 'Shakespeare' }"
        @click="navigateTo('/shakespeare')"
      >
        莎士比耶助手
      </div>
    </div>
  </aside>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router';
import { computed, ref } from 'vue';
import { APP_SIDEBAR_ITEMS } from '@/config/slowDramaWorkflows';

const router = useRouter();
const route = useRoute();
const isNavigating = ref(false);
const showExtendedLinks = ref(false);
const sidebarItems = computed(() => APP_SIDEBAR_ITEMS);

const navigateTo = async (path) => {
  // 防止重复点击和不必要的导航
  if (isNavigating.value || route.path === path) {
    return;
  }
  
  try {
    isNavigating.value = true;
    await router.push(path);
  } catch (error) {
    console.error('Navigation error:', error);
  } finally {
    isNavigating.value = false;
  }
};
</script>

<style scoped>
.sidebar {
  width: 240px;
  background: #fff;
  border-right: 1px solid var(--border-color);
  padding: 16px;
}
.section + .section { margin-top: 16px; }
.section-title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .06em;
  text-transform: uppercase;
  color: var(--text-secondary);
  margin: 6px 10px 10px;
}
.link {
  display: block;
  padding: 10px 12px;
  color: var(--text-primary);
  border-radius: 10px;
  text-decoration: none;
  transition: all .2s ease;
  cursor: pointer;
  user-select: none;
}
.link + .link {
  margin-top: 8px;
}
.link:hover {
  background: var(--background-tertiary);
}
/* 选中态：增加明显的选中背景色与描边，使用已存在主题变量 */
.link.active,
.link.router-link-exact-active {
  background: rgba(102, 126, 234, 0.12); /* 基于 --primary-color(#667eea) 的透明背景 */
  color: var(--primary-color);
  border: 1px solid var(--primary-light);
}
.action {
  width: 100%;
  margin-top: 8px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid var(--border-color);
  background: var(--background-tertiary);
  color: var(--text-primary);
  cursor: pointer;
  transition: all .2s ease;
}
.action:hover {
  background: var(--background-secondary);
  box-shadow: var(--shadow-sm);
}
/* 响应式：侧边栏适配 */
@media (max-width: 1200px) {
  .sidebar {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid var(--border-color);
    padding: 12px 16px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .section { display: flex; align-items: center; gap: 8px; }
  .section-title { margin: 0 8px 0 0; }
  .link { display: inline-flex; margin-right: 8px; }
  .link + .link { margin-top: 0; }
}
@media (max-width: 768px) {
  .sidebar { padding: 10px 12px; overflow-x: auto; }
  .link { white-space: nowrap; }
}
</style>
